import { Component, OnInit, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { Subscription, BehaviorSubject, Observable, of } from "rxjs";
import { filter, tap, mergeMap, finalize } from "rxjs/operators";

import { AuthService } from '../../services/auth.service';

import { LoaderService } from "../../common/services/loader.service";
import { SubHeaderService } from "../../core/services/sub-header.service";

import { Dashboard, DashboardLayoutKind, Widget, OrgModel } from "../models/dashboard.model";
import { LunaClaimValues, UserIdentity } from '../../models/user-identity.model';
import { OrganizationService } from '../../common/services/organization.service';
import { SubHeader } from "../../core/models/sub-header.model";
import { AgentOrg } from '../../models/agentOrg.model';


@Component({
    selector: 'view-dashboard',
    templateUrl: './view-dashboard.component.html',
    styleUrls: ['./view-dashboard.component.scss'],
    standalone: false
})

export class ViewDashboardComponent implements OnInit {
    public subHeader: SubHeader;
    public dashboard: Dashboard;
    public _layoutClassMatrix;
    dataSubscriptions: Subscription = new Subscription();
    public orgList: AgentOrg[] = [];
    public userName: string;

    public showDdl: boolean = true;  
    public orgArray: OrgModel[] = [];
    public selectedVal: string = "";

    constructor(
        public route: ActivatedRoute,
        public router: Router,
        public subHeaderService: SubHeaderService,
        public loaderService: LoaderService,
        public organizationService: OrganizationService,
        public authService: AuthService
    ) {
        //hack for bug with routing will need to be revisited with a better routing strategy
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this._layoutClassMatrix = this.initLayoutClassMatrix();
    }

    ngOnInit() {

        this.loaderService.toggleLoader(true);  //long wait here, show something to user

        if (window.sessionStorage.getItem('levelInfo')) {
            window.sessionStorage.removeItem('levelInfo')
        }
        if (window.sessionStorage.getItem('coInfo')) {
            window.sessionStorage.removeItem('coInfo');
        }
        
        this.userName = this.authService.User.email;

        if (sessionStorage.getItem("orgList")) {
            this.orgList = JSON.parse(sessionStorage.getItem("orgList"));
            this.orgList.forEach(v => {
                this.orgArray.push({
                    "orgId": v.orgId,
                    "orgName": v.orgName
                });
            });
        }
        let org$ = this.authService.selectedOrganization$.pipe().subscribe(
            (org) => {
                this.loadData(org);
            },
            (error) => {
                console.error(error);
            });
        this.dataSubscriptions.add(org$);
        this.loaderService.toggleLoader(false); 
     }

    ngOnDestroy() {
        this.dataSubscriptions.unsubscribe();
    }

    loadData(orgId: string) {
        this.dashboard = this.route.snapshot.data.dashboard;
        let canManageDashboards = this.authService.hasSystemPermission(LunaClaimValues.ManageDashboards);
        let dashboardName = this.dashboard.title;

        let matching = this.orgArray.filter(x => x.orgId === orgId);
        if (matching && matching.length > 0 && (this.dashboard.title == "" || this.dashboard.title == undefined || this.dashboard.title == null || this.dashboard.id === "external_default" || this.dashboard.id === "ricsDashboard")) {
            if (this.isValidString(matching[0].orgName)) {
                dashboardName = `${matching[0].orgName} Dashboard`;
            } else if (this.isValidString(matching[0].orgId)) {
                dashboardName = `${matching[0].orgId} Dashboard`;
            }

        }

        this.subHeader = new SubHeader({ title: dashboardName, buttons: canManageDashboards ? [{ name: "Edit Dashboard", method: () => this.editDashboard() }] : [] });
        this.subHeaderService.updateSubHeader(this.subHeader);
        this.loaderService.toggleLoader(false);
        let router$ = this.router.events.pipe(filter(e => e instanceof NavigationStart)).subscribe((routerEvent: NavigationStart) => {
            this.dataSubscriptions.unsubscribe();
        });
        this.dataSubscriptions.add(router$);         
           
    }

    isValidString(valueToCheck: string) {
        return valueToCheck !== null && valueToCheck !== undefined && valueToCheck !== "";
    }

    public initLayoutClassMatrix(): any {
        let result = {};
        result[DashboardLayoutKind.ThreeColumn] = ["medium-3", "medium-3", "medium-3"];
        result[DashboardLayoutKind.TwoColumnRightLarge] = ["medium-4", "medium-8"];
        result[DashboardLayoutKind.TwoColumnLeftLarge] = ["medium-8", "medium-4"];
        result[DashboardLayoutKind.TwoColumnEqual] = ["medium-6", "medium-6"];
        result[DashboardLayoutKind.SingleColumn] = ["medium-12"];
        return result;
    }

    chooseOrganization(): void {
        this.loaderService.toggleLoader(true);
        this.router.navigate(["home", "select-organization"]);
    }

    public editDashboard(): void {
        this.router.navigate(['/dashboard/edit', this.dashboard.id]);
    }

    public hasWidgetPermission(widget: Widget): boolean {
        return this.authService.hasWidgetPermission(widget);
    }

    public getLayout(columnIndex: number): string {
        const columnLayouts = this._layoutClassMatrix[this.dashboard.layout];
        if (columnLayouts) {
            if (columnLayouts[columnIndex]) {
                return columnLayouts[columnIndex];
            }
        }
        return "medium-12";
    }
}
